import React from 'react';
import BunnyLoading from '../components/BunnyLoading';
import useExternalAuthEntry from '../customHooks/useExternalAuthEntry';

/**
 * Displays a loading indicator while navigating after external authentication.
 * @param {object} props Matched authentication route and destination URL.
 * @returns {React.ReactElement} Loading indicator.
 */
const RedirectToOwnerPortal = ({ match, redirectTo }) => {
    useExternalAuthEntry({ params: match.params, redirectTo });

    return (
        <div className='App'>
            <BunnyLoading />
        </div>
    );
};

export default RedirectToOwnerPortal;
